export default "__VITE_ASSET__BRFKspiH__"